import { getUsdcContractAddresses } from '@/utils/trade-contracts';

/** Polygon 上 getLogs 回溯块数（约 3–4 分钟） */
export const DEPOSIT_FROM_BLOCK_LOOKBACK = 80;

export function resolveDefaultChainId() {
  const id = Number(process.env.VUE_APP_CHAIN_ID);
  return Number.isFinite(id) && id > 0 ? id : 137;
}

/** 区块浏览器根 URL（Polygon 默认 polygonscan） */
export function resolveDepositExplorerUrl(chainId) {
  const id = Number(chainId);
  if (id === 137 || !Number.isFinite(id) || id <= 0) {
    return 'https://polygonscan.com';
  }
  return 'https://polygonscan.com';
}

/**
 * 纯前端兜底：无 contract 时仅对 USDC 使用 env 合约（native + bridged）。
 * USDT 不得 silently 挂到 USDC 合约，否则会把 USDC 入账标成 USDT。
 * Cobo 有时只返回其中一个 USDC 合约地址，仍补齐双合约以免漏扫。
 * @param {{ rcContractAddress?: string, tokenSymbol?: string }} params
 * @returns {string[]}
 */
export function resolveDepositWatchContracts({ rcContractAddress, tokenSymbol = 'USDC' } = {}) {
  const rc = String(rcContractAddress ?? '').trim();
  const sym = String(tokenSymbol ?? '')
    .trim()
    .toUpperCase();

  if (sym === 'USDT' || sym === 'USDT.E' || sym === 'USDTE') {
    return rc ? [rc] : [];
  }

  const usdcList = getUsdcContractAddresses();
  if (rc) {
    return [...new Set([rc, ...usdcList].filter(Boolean))];
  }
  return usdcList;
}

export function normalizeTokenContracts(input) {
  const list = Array.isArray(input) ? input : input ? [input] : [];
  return [...new Set(list.map((item) => String(item ?? '').trim()).filter(Boolean))];
}

export function buildDepositWatchKey(watchAddress, tokenContracts) {
  const contracts = normalizeTokenContracts(tokenContracts)
    .map((c) => c.toLowerCase())
    .sort()
    .join(',');
  return `${String(watchAddress ?? '').toLowerCase()}:${contracts}`;
}
